module.exports = __webpack_public_path__ + "static/media/registry-white-bg-trimmed.f8aae6b6.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/icons/registry-white-bg-trimmed.svg
 ** module id = 939
 ** module chunks = 44
 **/